export const EMPTY_FORM = { name: '', email: '', phone: '', city: '' };